import { put, call, takeLatest } from "redux-saga/effects";
import { Api } from "../Service/api";
import {
  BOARDFAILURE,
  BOARDREQUEST,
  BOARDSUCCESS,
  GET_USER_FAILED,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  LOGINFAILURE,
  LOGINREQUEST,
  LOGINSUCCESS,
  MEDIUMFAILURE,
  MEDIUMREQUEST,
  MEDIUMSUCCESS,
  NOTICEFAILURE,
  NOTICEREQUEST,
  NOTICESUCCESS,
  SEMESTERAUTOFAILURE,
  SEMESTERAUTOREQUEST,
  SEMESTERAUTOSUCCESS,
  SEMESTERFAILURE,
  SEMESTERREQUEST,
  SEMESTERSUCCESS,
  STANDARDAUTOFAILURE,
  STANDARDAUTOREQUEST,
  STANDARDAUTOSUCCESS,
  STANDARDFAILURE,
  STANDARDREQUEST,
  STANDARDSUCCESS,
  SUBJECTAUTOFAILURE,
  SUBJECTAUTOREQUEST,
  SUBJECTAUTOSUCCESS,
  SUBJECTFAILURE,
  SUBJECTREQUEST,
  SUBJECTSUCCESS,
} from "./actionTypes";
import { ACTIONS } from "./actions";



export function* GetLoginAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.Login, JSON.stringify(params));
    yield put({
      type: LOGINSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: LOGINFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetBoardAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetBoard, params);
    yield put({
      type: BOARDSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: BOARDFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetMediumAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetMediam, params);
    yield put({
      type: MEDIUMSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: MEDIUMFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetStandardAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetStandard, params);
    yield put({
      type: STANDARDSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: STANDARDFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetAutoStandardAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetAutoStandard, params);
    yield put({
      type: STANDARDAUTOSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: STANDARDAUTOFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetSemesterAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetSemester, params);
    yield put({
      type: SEMESTERSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: SEMESTERFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetAutoSemesterAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetAutoSemester, params);
    yield put({
      type: SEMESTERAUTOSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: SEMESTERAUTOFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetSubjectAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetSubject, params);
    yield put({
      type: SUBJECTSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: SUBJECTFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetAutoSubjectAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetAutoSubject, params);
    yield put({
      type: SUBJECTAUTOSUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: SUBJECTAUTOFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetNoticeAsync({ payload }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetNotice, payload);
    yield put({
      type: NOTICESUCCESS,
      payload: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: NOTICEFAILURE, payload: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export function* GetUserAsync({ params }) {
  try {
    yield put(ACTIONS.startLoading());
    const response = yield call(Api.GetUser, params);
    yield put({
      type: GET_USER_SUCCESS,
      params: JSON.parse(response?.data),
    });
  } catch (e) {
    yield put({ type: GET_USER_FAILED, params: e });
  } finally {
    yield put(ACTIONS.stopLoading());
  }
}

export default function* rootSaga() {
  yield takeLatest(LOGINREQUEST, GetLoginAsync);
  yield takeLatest(BOARDREQUEST, GetBoardAsync);
  yield takeLatest(MEDIUMREQUEST, GetMediumAsync);
  yield takeLatest(STANDARDREQUEST, GetStandardAsync);
  yield takeLatest(SEMESTERREQUEST, GetSemesterAsync);
  yield takeLatest(SUBJECTREQUEST, GetSubjectAsync);

  yield takeLatest(STANDARDAUTOREQUEST, GetAutoStandardAsync);
  yield takeLatest(SEMESTERAUTOREQUEST, GetAutoSemesterAsync);
  yield takeLatest(SUBJECTAUTOREQUEST, GetAutoSubjectAsync);

  yield takeLatest(NOTICEREQUEST, GetNoticeAsync);
  yield takeLatest(GET_USER_REQUEST, GetUserAsync);
}
